(function () {
  'use strict';

  function trackEvent(name, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, params || {}));
    document.dispatchEvent(new CustomEvent(name, { detail: params || {} }));
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.bio3-header');
    if (!root) return;
    root = document; // page sections are siblings under <main>, so scope queries to the document

    trackEvent('bio_landing_view', { page: 'bio-3-step-reset' });

    /* ---------- generic click tracking ---------- */
    document.addEventListener('click', function (evt) {
      var el = evt.target.closest('[data-bio3-track]');
      if (!el) return;
      trackEvent(el.getAttribute('data-bio3-track'), { href: el.getAttribute('href') || null });
    });

    /* ---------- FAQ accordion ---------- */
    var faqItems = root.querySelectorAll('.bio3-faq-item');
    faqItems.forEach(function (item) {
      var btn = item.querySelector('.bio3-faq-q');
      var panel = item.querySelector('.bio3-faq-a-wrap');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var isOpen = item.getAttribute('data-open') === 'true';
        item.setAttribute('data-open', String(!isOpen));
        btn.setAttribute('aria-expanded', String(!isOpen));
        if (!isOpen) {
          trackEvent('faq_open', { question: btn.querySelector('.bio3-faq-q__text')?.textContent.trim() || '' });
        }
      });
    });

    /* ---------- Add-to-cart forms (progressive enhancement over native /cart/add) ---------- */
    var atcForms = root.querySelectorAll('.bio3-atc-form');
    atcForms.forEach(function (form) {
      var submitting = false;
      form.addEventListener('submit', function (evt) {
        if (submitting) { evt.preventDefault(); return; }
        var btn = form.querySelector('[type="submit"]');
        var status = form.querySelector('.bio3-form-status');
        var idInput = form.querySelector('[name="id"]');
        if (!btn || !idInput) return; // let native submit happen as ultimate fallback

        evt.preventDefault();
        submitting = true;
        var originalHTML = btn.innerHTML;
        btn.setAttribute('aria-disabled', 'true');
        btn.disabled = true;
        btn.innerHTML = '<span class="bio3-btn__spinner" aria-hidden="true"></span><span>Adding…</span>';
        if (status) { status.textContent = ''; status.removeAttribute('data-state'); }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: idInput.value, quantity: 1 }),
        })
          .then(function (res) {
            return res.json().then(function (data) { return { ok: res.ok, data: data }; });
          })
          .then(function (result) {
            if (!result.ok) {
              var msg = (result.data && (result.data.description || result.data.message)) || 'Could not add this to your cart. Please try again.';
              throw new Error(msg);
            }
            trackEvent('cart_add_success', { variant_id: idInput.value });
            btn.innerHTML = '<span>Added ✓</span>';
            if (status) {
              status.textContent = 'Added to your cart. Redirecting…';
              status.setAttribute('data-state', 'success');
            }
            window.setTimeout(function () {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            }, 500);
          })
          .catch(function (err) {
            btn.innerHTML = originalHTML;
            btn.removeAttribute('aria-disabled');
            btn.disabled = false;
            submitting = false;
            if (status) {
              status.textContent = err.message || 'Something went wrong. Please try again.';
              status.setAttribute('data-state', 'error');
            }
            trackEvent('cart_add_error', { message: err.message });
          });
      });
    });

    /* ---------- Sticky mobile CTA ----------
       Driven by scroll position (getBoundingClientRect), throttled with a plain timer
       rather than requestAnimationFrame — rAF is paused in backgrounded/inactive tabs
       on some browsers, which would otherwise stall the sticky bar's visibility. */
    var sticky = document.querySelector('[data-bio3-sticky]');
    var heroCta = document.querySelector('[data-bio3-hero-cta]');
    var finalCta = document.querySelector('[data-bio3-final]');
    if (sticky && heroCta) {
      var throttleTimer = null;

      var updateVisibility = function () {
        if (window.matchMedia('(min-width: 900px)').matches) {
          sticky.classList.remove('is-visible');
          return;
        }
        var pastHero = heroCta.getBoundingClientRect().bottom < 0;
        var inFinal = finalCta ? finalCta.getBoundingClientRect().top < window.innerHeight * 0.9 : false;
        sticky.classList.toggle('is-visible', pastHero && !inFinal);
      };

      var requestUpdate = function () {
        if (throttleTimer) return;
        throttleTimer = window.setTimeout(function () {
          throttleTimer = null;
          updateVisibility();
        }, 100);
      };

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      updateVisibility();
    }
  });
})();
